module.exports = __webpack_public_path__ + "media/images/flags/4x3/fin-f972d4ad6d0c43f50da600e5a7d8075f.svg";